<template>
  <div>
    <table-manager
      @filterChanged="filterChanged"
      @paginationChanged="paginationChanged"
      @ClickOnAddButton="ClickOnAddButton"
      :options="options"/>
    <basic-table
      v-if="systemUsers"
      :items="systemUsers"
      :fields="fields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="ClickOnEditButton"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      :isDelete="isDelete"
      isEdit="true"/>
    <table-manager-bottom style="margin:5px"
      v-if="systemUsers"
      :totalRows="totalRows"
      :perPage="perPage"
      v-model="currentPage"/>
    <b-modal ref="form" hide-footer>
      <Form @refreshTable="refreshTable" @makeToasts="makeToasts" @hide="hideForm" :systemUser="systemUser"/>
    </b-modal>
  </div>
</template>

<script>
import Form from './form'

export default {
  data () {
    return {
      options: {
        isShowAddButton: true
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      isDelete: true,
      fields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'ip4', label: this.$i18n.t('IPv4'), sortable: true },
        { key: 'ip6', label: this.$i18n.t('IPv6'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      systemUser: null,
      sysUserToDelete: null
    }
  },
  components: {
    Form
  },
  methods: {
    hideForm () {
      this.$refs.form.hide()
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    refreshTable () {
      this.hideForm()
      this.$store.dispatch('SystemUsers/GET_SYSTEM_USERS')
    },
    filterChanged (value) {
      this.filter = value
    },
    showForm () {
      this.$refs.form.show()
    },
    ClickOnAddButton () {
      this.systemUser = null
      this.showForm()
    },
    ClickOnEditButton (row) {
      this.systemUser = row
      this.showForm()
    },
    ClickOnDeleteButton (row) {
      this.sysUserToDelete = row
      if (this.sysUserToDelete) {
        this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "User"?', this.deleteUser)
      }
    },
    deleteUser () {
      let response = this.$store.dispatch('SystemUsers/DELETE_SYSTEM_USER', this.sysUserToDelete.user_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.refreshTable()
          this.$root.$emit('makeToasts')
        }
      })
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    systemUsers () {
      return this.$store.getters['SystemUsers/SYSTEM_USERS'].filter(item => { return item.login.toUpperCase().includes(this.filter.toUpperCase()) })
    }
  },
  mounted () {
    this.$store.dispatch('SystemUsers/GET_SYSTEM_USERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemUsers/main.vue